import { ILogger, ILogTransmitter, IRawLogs } from '../types';

/**
 * Base Logger
 */
export class Logger implements ILogger {
  transmitter!: ILogTransmitter;

  /**
   * log - transmits logs to the log transmitter
   */
  log(rawLogs: IRawLogs): void {
    this.transmitter.transmit(rawLogs);
  }

  getLogMethods(): string[] {
    throw new Error('Not Implemented');
  }

  set logTransmitter(logTransmitter: ILogTransmitter) {
    this.transmitter = logTransmitter;
  }
}
